/*
 * @ Author: wangjiyu
 * @Date: 2020-04-10 11:05:38
 * @LastEditTime: 2020-04-16 14:08:42
 * @LastEditors: wangjiyu
 * @Description: file content
 */

import addTitleDialogCtrlDom from './addTitleDialogCtrl';

let addTitleDialogCtrl;
const addTitleDialog = (confirmCallback, editCallback, title) => {
    if (!addTitleDialogCtrl) addTitleDialogCtrl = addTitleDialogCtrlDom;
    return addTitleDialogCtrl.addDialog({
        confirmCallback,
        editCallback,
        title,
    });
};

export default {
    init(initParam: {
        confirmCallback?: (title: string) => void;
        editCallback?: (title: string) => void;
    }) {
        return {
            show(title?: string) {
                return addTitleDialog(
                    initParam.confirmCallback,
                    initParam.editCallback,
                    title
                );
            },
            close() {
                return addTitleDialogCtrl.destroy();
            },
        };
    },
};
